import pluralize from 'pluralize';

import { Component, Input } from '@angular/core';

import { snFadeIn, snFadeOut } from '@lib/common/animations';

@Component({
  selector: 'sn-message-typing',
  templateUrl: './message-typing.component.html',
  styleUrls: ['./message-typing.component.scss'],
  animations: [snFadeIn, snFadeOut],
})
export class SnMessageTypingComponent {
  @Input() set typingMembers(value: string[]) {
    if (value.length > 0) {
      const memberNames = value.join(', ');
      this.typingMessage = `${memberNames} ${pluralize('is', value.length)} typing`;
    } else {
      this.typingMessage = undefined;
    }
  }

  public typingMessage: string;

  constructor() {}
}
